import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const PREFIX = "SkipAdButton";

const classes = {
  topLeft: `${PREFIX}-topLeft`,
  topRight: `${PREFIX}-topRight`,
  bottomLeft: `${PREFIX}-bottomLeft`,
  bottomRight: `${PREFIX}-bottomRight`,
};

const TOP_LEFT = "top_left";
const TOP_RIGHT = "top_right";
const BOTTOM_LEFT = "bottom_left";
const BOTTOM_RIGHT = "bottom_right";

const StyledButton = styled(Button)(() => ({
  [`&.${classes.topLeft}`]: {
    position: "absolute",
    top: 10,
    left: 10,
    zIndex: 100000,
  },

  [`&.${classes.topRight}`]: {
    position: "absolute",
    top: 10,
    right: 10,
    zIndex: 100000,
  },

  [`&.${classes.bottomLeft}`]: {
    marginRight: "auto",
  },

  [`&.${classes.bottomRight}`]: {
    marginLeft: "auto",
  },
}));

export function isSkipButtonAbsolute(position) {
  return position?.startsWith("top") ?? false;
}

export default function SkipAdButton({
  onClick,
  canSkip,
  skipTimeout,
  position,
}) {
  const { t } = useTranslation("core");
  const resolvedPosition = position ?? BOTTOM_RIGHT;

  return (
    <StyledButton
      onClick={onClick}
      variant="contained"
      disabled={!canSkip}
      size="small"
      className={classNames({
        [classes.topLeft]: resolvedPosition === TOP_LEFT,
        [classes.topRight]: resolvedPosition === TOP_RIGHT,
        [classes.bottomLeft]: resolvedPosition === BOTTOM_LEFT,
        [classes.bottomRight]: resolvedPosition === BOTTOM_RIGHT,
      })}
    >
      {canSkip ? t("adv.skipAd") : t("adv.skipAfter", { count: skipTimeout })}
    </StyledButton>
  );
}

SkipAdButton.propTypes = {
  onClick: PropTypes.func,
  canSkip: PropTypes.bool,
  skipTimeout: PropTypes.number,
  position: PropTypes.oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_LEFT, BOTTOM_RIGHT]),
};
